import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { AsyncJobType } from '@recruitee/account/data';
import { bulkActionEffectFactory } from '@recruitee/async-job/data';

import { BulkActionsHttpClient } from './bulk-actions-http-client';
import { CandidateBulkActions } from './bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class CandidateBulkActionsEffects {
  public addTask$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'addTask',
    AsyncJobType.BulkCandidatesAddTask,
    params => this.bulkActionsHttpClient.addTask(params),
  );

  public delete$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'delete',
    AsyncJobType.BulkCandidatesDeleteCandidates,
    params => this.bulkActionsHttpClient.delete(params),
  );

  public follow$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'follow',
    AsyncJobType.BulkCandidatesFollow,
    params => this.bulkActionsHttpClient.follow(params),
  );

  public unfollow$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'unfollow',
    AsyncJobType.BulkCandidatesUnfollow,
    params => this.bulkActionsHttpClient.unfollow(params),
  );

  public requalify$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'requalify',
    AsyncJobType.BulkCandidatesRequalify,
    params => this.bulkActionsHttpClient.requalify(params),
  );

  public disqualify$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'disqualify',
    AsyncJobType.BulkCandidatesDisqualify,
    params => this.bulkActionsHttpClient.disqualify(params),
  );

  public assign$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'assign',
    AsyncJobType.BulkCandidatesAssign,
    params => this.bulkActionsHttpClient.assign(params),
  );

  public unassign$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'unassign',
    AsyncJobType.BulkCandidatesUnassign,
    params => this.bulkActionsHttpClient.unassign(params),
  );

  public changeStage$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'changeStage',
    AsyncJobType.BulkCandidatesChangeStage,
    params => this.bulkActionsHttpClient.changeStage(params),
  );

  public addTags$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'addTags',
    AsyncJobType.BulkCandidatesAddTags,
    params => this.bulkActionsHttpClient.addTags(params),
  );

  public addSources$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'addSources',
    AsyncJobType.BulkCandidatesAddSources,
    params => this.bulkActionsHttpClient.addSources(params),
  );

  public extendGdprExpirationDate$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'extendGdprExpirationDate',
    AsyncJobType.BulkCandidatesSetGdprCustomExpiresAt,
    params => this.bulkActionsHttpClient.extendGdprExpirationDate(params),
  );

  public retrieve$ = bulkActionEffectFactory(
    this.actions$,
    CandidateBulkActions,
    'retrieve',
    AsyncJobType.BulkCandidatesRetrieveCandidates,
    params => this.bulkActionsHttpClient.retrieve(params),
  );

  constructor(public bulkActionsHttpClient: BulkActionsHttpClient, private actions$: Actions) {}
}
